import {
  BaseFilterMany,
  BaseFilterOne,
  BaseQueryMany,
  DateTimeRange,
} from '@cnx-saas/common';
import { LoadStatus } from '@cnx-saas/loads';
import { CnxIdType } from '@cnx-saas/utils-cnx-id';
import { Load, Loads } from './Load';
import { Location } from './Location';

export class FilterLoad extends BaseFilterOne(CnxIdType.Load) {}
export class FilterLoads extends BaseFilterMany(CnxIdType.Load) {}

export class LoadFilters {
  externalReference?: string;
  articleIds?: string[];
  createdAt?: DateTimeRange;
  loadingDate?: DateTimeRange;
  unloadingDate?: DateTimeRange;
  pickUpLocationIds?: string[];
  dropOffLocationIds?: string[];
  selectedDepotLocationId?: string;
  depotLocationsIds?: string[];
  loadingFullDate?: string;
  timezone?: string;
  status?: LoadStatus[];
  loadIds?: string[];
  isPlannedFor?: boolean;
}

export class QueryLoads extends BaseQueryMany<LoadFilters>() {}

export interface LoadQueryVariables {
  filter: FilterLoad;
}
export interface LoadQueryResult {
  load: Load;
}

export interface LoadsQueryVariables {
  query: QueryLoads;
}
export interface LoadsQueryResult {
  loads: Loads;
}

export interface LoadsByExternalReferencesQueryVariables {
  externalReferences: string[];
}

export enum ChartGroupByLoadStatus {
  PRE_PLANNED = 'PRE_PLANNED',
  UNPLANNED = 'UNPLANNED',
}

export interface LoadCountByDepotFilters {
  groupByLoadStatus: ChartGroupByLoadStatus;
}

export interface LoadCountByDepot {
  depot: Location;
  count: number;
  date?: string; // ISO date string
}
